import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const CloseIcon = ({ size, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: rest.fill,
      d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  ) });
};
export {
  CloseIcon
};
